import AccountPage from '@fhs-legacy/frontend/src/pages/account';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default AccountPage;
